"use strict";

/* -------------------------------------------------------------------------

	PUNITED.sustainability

	トップページのスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */
// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.sustainability) PUNITED.sustainability = {};

(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.sustainability;
  /* -----------------------------------------------------
  
  ----------------------------------------------------- */
})();

$(function () {
  PUNITED.utils.headLine({
    width: 1903.102,
    height: 204.879,
    d: [{
      command: 'M',
      points: [[-13744.392, -11529.979]]
    }, {
      command: 'c',
      points: [[-203.186, -75.585], [-215.453, -113.445], [-434.984, -182.437]]
    }, {
      command: 's',
      points: [[-472.566, 54.535], [-769.484, 82.75], [-698.051, -67.883], [-698.051, -67.883]]
    }],
    translate: [15647.145, 11733.92]
  }, {
    width: 428.992,
    height: 47.632,
    d: [{
      command: 'M',
      points: [[-15218.5, -11687.346]]
    }, {
      command: 'c',
      points: [[-45.754, -17.021], [-48.517, -25.547], [-97.951, -41.082]]
    }, {
      command: 's',
      points: [[-106.412, 12.28], [-173.271, 18.634], [-157.187, -15.286], [-157.187, -15.286]]
    }],
    translate: [15647.146, 11734.04]
  });
});